import React from 'react';
import { BookingsTableData, BookingTableCellProps } from './helpers';
import { PopoverOnOverflow } from '@round/ui-kit';
import Badge from '../../../ui/Badge/Badge';
import styles from './BookingsTable.module.css';
import cn from 'classnames';

const InfoCell = <T extends BookingsTableData>({
    value,
    row: {
        original: { is_created_by_client },
    },
    className,
}: BookingTableCellProps<T> & { className?: string }) => {
    return value !== null && value !== undefined ? (
        <PopoverOnOverflow
            popoverContent={<div className={styles.tooltip}>{value}</div>}
            popoverOptions={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
        >
            {(setRef) => (
                <Badge
                    ref={setRef}
                    className={cn(styles.badge, styles.info, className, {
                        [styles.createdByClient]: is_created_by_client,
                    })}
                >
                    {value}
                </Badge>
            )}
        </PopoverOnOverflow>
    ) : null;
};

export default InfoCell;
